export default __webpack_public_path__ + "src/dataset/galleries-a2b1-1bbb07.txt";